import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';

const exclusionService = {
  async createExclusion(alias: string, phrase: string) {
    try {
      const res = await defaultAxios.post(`/exclusions/${alias}/element`, {
        element: phrase,
      });
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async fetchExclusionList(): Promise<FetchExclusionListResponse> {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(`/workspaces/${wa}/exclusion`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async updateExclusion(alias: string, index: number, phrase: string) {
    try {
      const res = await defaultAxios.patch(
        `/exclusions/${alias}/element/${index}`,
        {
          element: phrase,
        },
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async deleteExclusion(alias: string, index: number) {
    try {
      const res = await defaultAxios.delete(
        `/exclusions/${alias}/element/${index}`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};

export default exclusionService;
